'use strict';

var _ = require('lodash');

var util = {
	/**
	 * @function
	 * @description appends the parameter with the given name and value to the given url and returns the changed url
	 * @param {String} url the url to which the parameter will be added
	 * @param {String} name the name of the parameter
	 * @param {String} value the value of the parameter
	 */
	appendParamToURL: function (url, name, value) {
		// quit if the param already exists
		if (url.indexOf(name + '=') !== -1) {
			return url;
		}
		var separator = url.indexOf('?') !== -1 ? '&' : '?';
		return url + separator + name + '=' + encodeURIComponent(value);
	},
	/**
	 * @function
	 * @description appends the parameters to the given url and returns the changed url
	 * @param {String} url the url to which the parameters will be added
	 * @param {Object} params
	 */
	appendParamsToUrl: function (url, params) {
		var _url = url;
		_.each(params, function (value, name) {
			_url = this.appendParamToURL(_url, name, value);
		}.bind(this));
		return _url;
	},
	/**
	 * @function
	 * @description extract the query string from URL
	 * @param {String} url the url to extra query string from
	 **/
	getQueryString: function (url) {
		var qs;
		if (!_.isString(url)) { return; }
		var a = document.createElement('a');
		a.href = url;
		if (a.search) {
			qs = a.search.substr(1); // remove the leading ?
		}
		return qs;
	},
	/**
	 * @function
	 * @description
	 * @param {String}
	 * @param {String}
	 */
	elementInViewport: function (el, offsetToTop) {
		var top = el.offsetTop,
			left = el.offsetLeft,
			width = el.offsetWidth,
			height = el.offsetHeight;

		while (el.offsetParent) {
			el = el.offsetParent;
			top += el.offsetTop;
			left += el.offsetLeft;
		}

		if (typeof(offsetToTop) !== 'undefined') {
			top -= offsetToTop;
		}

		if (window.pageXOffset !== null) {
			return (
				top < (window.pageYOffset + window.innerHeight) &&
				left < (window.pageXOffset + window.innerWidth) &&
				(top + height) > window.pageYOffset &&
				(left + width) > window.pageXOffset
			);
		}

		if (document.compatMode === 'CSS1Compat') {
			return (
				top < (window.document.documentElement.scrollTop + window.document.documentElement.clientHeight) &&
				left < (window.document.documentElement.scrollLeft + window.document.documentElement.clientWidth) &&
				(top + height) > window.document.documentElement.scrollTop &&
				(left + width) > window.document.documentElement.scrollLeft
			);
		}
	},

	/**
	 * @function
	 * @description Appends the parameter 'format=ajax' to a given path
	 * @param {String} path the relative path
	 */
	ajaxUrl: function (path) {
		return this.appendParamToURL(path, 'format', 'ajax');
	},

	/**
	 * @function
	 * @description
	 * @param {String} url
	 */
	toAbsoluteUrl: function (url) {
		if (url.indexOf('http') !== 0 && url.charAt(0) !== '/') {
			url = '/' + url;
		}
		return url;
	},
	/**
	 * @function
	 * @description Loads css dynamically from given urls
	 * @param {Array} urls Array of urls from which css will be dynamically loaded.
	 */
	loadDynamicCss: function (urls) {
		var i, len = urls.length;
		for (i = 0; i < len; i++) {
			this.loadedCssFiles.push(this.loadCssFile(urls[i]));
		}
	},

	/**
	 * @function
	 * @description Loads css file dynamically from given url
	 * @param {String} url The url from which css file will be dynamically loaded.
	 */
	loadCssFile: function (url) {
		return $('<link/>').appendTo($('head')).attr({
			type: 'text/css',
			rel: 'stylesheet'
		}).attr('href', url); // for i.e. <9, href must be added after link has been appended to head
	},
	// array to keep track of the dynamically loaded CSS files
	loadedCssFiles: [],

	/**
	 * @function
	 * @description Removes all css files which were dynamically loaded
	 */
	clearDynamicCss: function () {
		var i = this.loadedCssFiles.length;
		while (0 > i--) {
			$(this.loadedCssFiles[i]).remove();
		}
		this.loadedCssFiles = [];
	},
	/**
	 * @function
	 * @description Extracts all parameters from a given query string into an object
	 * @param {String} qs The query string from which the parameters will be extracted
	 */
	getQueryStringParams: function (qs) {
		if (!qs || qs.length === 0) { return {}; }
		var params = {},
			unescapedQS = decodeURIComponent(qs);
		// Use the String::replace method to iterate over each
		// name-value pair in the string.
		unescapedQS.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
			function ($0, $1, $2, $3) {
				params[$1] = $3;
			}
		);
		return params;
	},
	fillAddressFields: function (address, $form) {
		for (var field in address) {
			if (field === 'ID' || field === 'UUID' || field === 'key') {
				continue;
			}
			// if the key in address object ends with 'Code', remove that suffix
			// keys that ends with 'Code' are postalCode, stateCode and countryCode
			$form.find('[name$="' + field.replace('Code', '') + '"]').val(address[field]);
			// update the state fields
			if (field === 'countryCode') {
				$form.find('[name$="country"]').trigger('change');
				// retrigger state selection after country has changed
				// this results in duplication of the state code, but is a necessary evil
				// for now because sometimes countryCode comes after stateCode
				$form.find('[name$="county"]').val(address.stateCode);
			}
			if (field === 'postalCode') {
				$form.find('[name$="zip"]').val(address.postalCode);
			}
		}
	},

	limitCharatersCounter: function ($element) {

		var controlKeys = ['8', '13', '46', '45', '36', '35', '38', '37', '40', '39'];

		var $baseElement;
		if (typeof $element === 'undefined') {
			$baseElement = $('body');
		} else {
			$baseElement = $element;
		}

		$baseElement
			.on('keydown', 'textarea[data-character-limit]', function (e) {
				var text = $.trim($(this).val()),
					charsLimit = $(this).data('character-limit'),
					charsUsed = text.length;

					if ((charsUsed >= charsLimit) && (controlKeys.indexOf(e.which.toString()) < 0)) {
						e.preventDefault();
					}
			})
			.on('change keyup mouseup', 'textarea[data-character-limit]', function () {
				var text = $.trim($(this).val()),
					charsLimit = $(this).data('character-limit'),
					charsUsed = text.length,
					charsRemain = charsLimit - charsUsed;

				if (charsRemain < 0) {
					$(this).val(text.slice(0, charsRemain));
					charsRemain = 0;
				}

				$(this).parent().children('.char-count').find('.char-remain-count').html(charsRemain);
			});
	},
	/**
	 * @function
	 * @description Counts characters and updates, left amount
	 * based on the character limit in a text area
	 */
	initCharactersCount: function () {
		$('input[data-character-count], textarea[data-character-count]').on('change keyup input', function () {
			var $this = $(this),
				charsLimit = $this.data('character-count'),
				charsUsed = util.getCharsUsed($this),
				charsRemain = charsLimit - charsUsed;
			if (charsRemain < 0) {
				charsRemain = 0;
			}

			$(this).parent().children('.char-count').find('.char-remain-count').html(charsRemain);
		});
	},
	/**
	 * @function
	 * @description count chars in textArea
	 *  window.Constants.GIFT_MSG_MERGE_NEW_LINES could have a differece
	 */
	getCharsUsed: function ($el) {
		var perLine = window.Constants.GIFT_MSG_CHARS_PER_LINE,
			textOrigin = $el.val() || '',
			lines = textOrigin.split('\n'),
			filledLines = lines.length - 1,
			lastLineCharCount = lines[filledLines].length;
		return filledLines * perLine + lastLineCharCount;
	},
	/**
	 * @function
	 * @description Updates the number of the remaining character
	 * based on the character limit in a text area
	 */
	limitCharacters: function ($element) {
		var $baseElement;
		if (typeof $element === 'undefined') {
			$baseElement = $('body');
		} else {
			$baseElement = $element;
		}

		$baseElement.find('textarea[data-character-limit],input[data-character-count],textarea[data-character-count]').each(function () {
			var characterLimit = $(this).data('character-limit') || $(this).data('character-count');
			var charCountHtml = String.format(Resources.CHAR_LIMIT_MSG,
				'<span class="char-remain-count">' + characterLimit + '</span>',
				'<span class="char-allowed-count">' + characterLimit + '</span>');
			var charCountContainer = $(this).next('div.char-count');
			if (charCountContainer.length === 0) {
				charCountContainer = $('<div class="char-count"/>').insertBefore($(this));
			}
			charCountContainer.html(charCountHtml);
			// trigger the keydown event so that any existing character data is calculated
			$(this).change();
		});
	},
	/**
	 * @function
	 * @description Binds the onclick-event to a delete button on a given container,
	 * which opens a confirmation box with a given message
	 * @param {String} container The name of element to which the function will be bind
	 * @param {String} message The message the will be shown upon a click
	 */
	setDeleteConfirmation: function (container, message) {
		$(container).on('click', '.delete', function () {
			return window.confirm(message);
		});
	},
	/**
	 * @function
	 * @description Scrolls a browser window to a given x point
	 * @param {String} The x coordinate
	 */
	scrollBrowser: function (xLocation) {
		$('html, body').animate({scrollTop: xLocation}, 500);
	},

	isMobile: function () {
		var mobileAgentHash = ['mobile', 'tablet', 'phone', 'ipad', 'ipod', 'android', 'blackberry', 'windows ce', 'opera mini', 'palm'];
		var	idx = 0;
		var isMobile = false;
		var userAgent = (navigator.userAgent).toLowerCase();

		while (mobileAgentHash[idx] && !isMobile) {
			isMobile = (userAgent.indexOf(mobileAgentHash[idx]) >= 0);
			idx++;
		}
		return isMobile;
	},

	/**
	 * @function
	 * @description Check whether a script is loaded, and if not, loads it. Then execute callback function.
	 * @param {Object} script object with path and loaded state
	 * @param {Function} callback function
	 */
	checkScriptLoaded: function (script, callback) {
		if (script.loaded) {
			if (typeof callback === 'function') { callback(); }
		} else {
			var useMin = window.Scripts.useMin,
				path = script.path;
			// Check to see if we are minifing the files
			if (useMin && ! (/\.min\.js$/.test(script.path))) {
				path = script.path.replace(/.js$/g, '.min.js');
			}
			// Loads a script based on the given path
			var loadScript = function (path) {
				// Execute the ajax call on the given script path
				var xhr = $.ajax({
					url: path,
					dataType: 'script',
					cache: true
				});
				// If the Ajax call was successful then perform the callback function if given
				xhr.done(function () {
					if (typeof callback === 'function') { callback(); }
					script.loaded = true;
				});
				// Return the jQuery XHR object
				return xhr;
			};
			// Load the script
			var xhr = loadScript(path);
			// Fall back to the standard path unless the standard path was used and not found
			xhr.fail(function (jqXHR, textStatus, errorThrown) {
				if (path !== script.path && (jqXHR.status === 404 || errorThrown === 'Not Found')) {
					loadScript(script.path);
				}
			});
		}
	},

	/**
	 * @function
	 * @description Returns an URI-Object from a given element with the following properties:<br/>
	 * <p>protocol</p>
	 * <p>host</p>
	 * <p>hostname</p>
	 * <p>port</p>
	 * <p>path</p>
	 * <p>query</p>
	 * <p>queryParams</p>
	 * <p>hash</p>
	 * <p>url</p>
	 * <p>urlWithQuery</p>
	 * @param {Object} o The HTML-Element
	 */
	getUri: function (o) {
		var a;
		if (o.tagName && $(o).attr('href')) {
			a = o;
		} else if (typeof o === 'string') {
			a = document.createElement('a');
			a.href = o;
		} else {
			return null;
		}

		return {
			protocol: a.protocol, // http:
			host: a.host, // www.myexample.com
			hostname: a.hostname, // www.myexample.com'
			port: a.port, // :80
			path: a.pathname, // /sub1/sub2
			query: a.search, // ?param1=val1&param2=val2
			queryParams: a.search.length > 1 ? util.getQueryStringParams(a.search.substr(1)) : {},
			hash: a.hash, // #OU812,5150
			url: a.protocol + '//' + a.host + a.pathname,
			urlWithQuery: a.protocol + '//' + a.host + a.port + a.pathname + a.search
		};
	},
	viewport: {
		isMobile: function () {
			return window.innerWidth < window.Constants.MEDIUM_BREAK_POINT;
		},
		isSmall: function () {
			return window.innerWidth < window.Constants.MEDIUM_BREAK_POINT;
		},
		isTablet: function () {
			return (window.innerWidth >= window.Constants.MEDIUM_BREAK_POINT) && (window.innerWidth < window.Constants.LARGE_BREAK_POINT);
		},
		isMedium: function () {
			return (window.innerWidth >= window.Constants.MEDIUM_BREAK_POINT) && (window.innerWidth < window.Constants.LARGE_BREAK_POINT);
		},
		isLarge: function () {
			return (window.innerWidth >= window.Constants.LARGE_BREAK_POINT) && (window.innerWidth < window.Constants.STANDARD_BREAK_POINT);
		},
		isStandard: function () {
			return window.innerWidth >= window.Constants.STANDARD_BREAK_POINT;
		}
	},

	sliderConfigs: function (options) {
		var o = options || {},
		configs = {
			infinite: false,
			arrows: true,
			speed: 300,
			dots: false,
			slidesToShow: o.instandard || 4,
			slidesToScroll: o.instandard || 4,
			responsive: [{
				breakpoint: window.Constants.STANDARD_BREAK_POINT - 1,
				settings: {
					slidesToShow: o.inlarge || 3,
					slidesToScroll: o.inlarge || 3
				}
			},
			{
				breakpoint: window.Constants.LARGE_BREAK_POINT - 1,
				settings: {
					slidesToShow: o.inmedium || 3,
					slidesToScroll: o.inmedium || 3
				}
			},
			{
				breakpoint: window.Constants.MEDIUM_BREAK_POINT - 1,
				settings: {
					slidesToShow: o.insmall || 1,
					slidesToScroll: o.insmall || 1
				}
			}]
		};
		return configs;
	},
	contentSliderConfig: function (number) {
		var configs = {
			infinite: false,
			speed: 300,
			slidesToShow: number && number > 0 ? number : 4
		};
		return configs;
	},

	// consider 0 widht of item in case of unexpectedly hidden elements
	getNumberOfItemsInCarousel: function ($container, minWidth) {
		var containerWidth = $container.width(),
			minItemWidth = minWidth || 210,
			arrows = 36,
			number = (containerWidth - arrows * 2) / minItemWidth;
		var numberOfItems = Math.floor(number);
		return numberOfItems >= 1 ? numberOfItems : 1;
	},

	iscrollParams: function () {

		var options = {
			scrollbars: 'custom',
			interactiveScrollbars: true,
			mouseWheel: true,
			tap:true
		};
		return options;
	},
	/*
	 * @param {number} decimal number from 0 to 1 progress indicator
	 * @param {string} canvasID - id of the canvas placeholder
	 */
	drawProgressWheel: function (percentage, canvasID) {
		var can = document.getElementById(canvasID);
		var context = can.getContext('2d');

		var degrees = (percentage * 360.0) - 90.0;
		var radians = degrees * (Math.PI / 180.0);

		var x = 75;
		var y = 75;
		var r = 57;
		var s = -0.5 * Math.PI;

		context.setTransform(1, 0, 0, 1, 0, 0);
		context.clearRect(0, 0, can.width, can.height);

		context.lineWidth = 8;

		// draw the grey background circle
		context.beginPath();
		context.strokeStyle = '#f4f4f4';
		context.arc(x, y, r, 0, 2 * Math.PI, false);
		context.stroke();

		// draw the green progress bar
		context.beginPath();
		context.strokeStyle = '#138f40';
		context.arc(x, y, r, s, radians, false);
		context.stroke();

		if (percentage > 1) {
			// draw the red warning progress bar
			context.beginPath();
			context.strokeStyle = '#bc0031';
			context.arc(x, y, r, s, radians - (1.5 * Math.PI) + s, false);
			context.stroke();
		}
	},
	/**
	 * @descr render interim layer between opened dropdown and the rest of site content
	 * @param {String} opacity - if specified add opacity to layer between opened dropdown
	 * @param {String} if 'dropDown' active dropdown would close the same like if you would
	 * move mouse off the dropdown; other or none value would close opened dropdown if you
	 * either tap or click outside active dropdown
	 */
	renderClosePadForTouch: function (opacity, dropDownType) {
		var events;
		// if the layer exists, do not create a new one, if there are multiples
		// of the layer, remove them all and create a new one
		if ($('.uiLayerIndicator').length === 1) {
			return;
		} else if ($('.uiLayerIndicator').length > 1) {
			$('.uiLayerIndicator').each(function (index, element) {
				$(element).remove();
			});
		}
		var uiLayer = document.createElement('div');
		uiLayer.className = opacity ? 'uiLayerIndicator opacity' : 'uiLayerIndicator';
		$('#navigation').append(uiLayer);
		$('#wrapper').append($(uiLayer).clone().css('height', $('#wrapper').height()));
		events = dropDownType === 'dropDown' ? 'touchstart mouseover' : 'touchstart click';
		$('.uiLayerIndicator').one(events, function (e) {
			e.preventDefault();
			$('.uiLayerIndicator').remove();
			$('body').find('.hover').removeClass('hover');
			$('.menu-wrapper').off('touchstart.nav');
		});
	},

	/**
	 * @function
	 * @description Encode a set of form elements as an
	 * object of based on names and values.
	 */
	serializeJSON: function ($form) {
		var serializeArray = $form.serializeArray();
		var i, arrayValue, len = serializeArray.length;
		var serializeJSON = {};
		for (i = 0; i < len; i++) {
			arrayValue = serializeArray[i];
			serializeJSON[arrayValue.name] = arrayValue.value;
		}
		return serializeJSON;
	},

	invalidCharsRegExp: /[^\w\s\u0040\u0024\u0023\u0027\u00A3\u003F\u003A\u0026\u002A\u007B\u007D\u005B\u005D\u002C\u003D\u002D\u0028\u0029\u002E\u002B\u003B\u002F\u0021\u005C\u007E\u0025\u005E\u007C]/gi,
	replaceInvalidCharsRegex: new RegExp(window.SitePreferences.INVALID_CHARS_PATTERN, 'g'),
	emojiRegex: new RegExp('[\ud83c-\udfff]|[\ud83d-\udfff]|[\u2600-\u27ff]', 'g'),
	/*
	 * " - 'Double quotes'
	 * ` - 'GRAVE ACCENT' (U+0060), alt + 096
	 * ‘ - 'LEFT SINGLE QUOTATION MARK' (U+2018) -
	 * ’ - 'RIGHT SINGLE QUOTATION MARK' (U+2019)
	 * ′ - 'PRIME' (U+2032)
	 * ’ - 'PRIVATE USE TWO' (U+0092), alt + 0146
	 * ´ - 'ACUTE ACCENT' (U+00B4) - alt 0180
	*/
	apostrophRegex: new RegExp('["`‘’′´\u0092]', 'g'),

	/**
	 * @function
	 * @description Exclude invalid characters
	 */
	removeInvalidChars: function (string) {
		string = string.replace(this.invalidCharsRegExp, '');
		string = string.replace(this.emojiRegex, '');
		var result = '';
		for (var i = 0; i < string.length; i++) {
			if (string.charCodeAt(i) <= 7929) {
				result += string[i];
			}
		}
		return result.trim();
	},

	/**
	 * @function
	 * @description Replaces invalid characters
	 */
	replaceInvalidChars: function (string) {
		string = string.replace(this.apostrophRegex, "'"); // jshint ignore:line
		string = string.replace(this.replaceInvalidCharsRegex, '');
		string = string.replace(this.invalidCharsRegExp, '');

		return string;
	},

	/**
	 * @function
	 * @description add attribute to mask sensitive info with delay for element to be fully loaded
	 * @param elementSelector page element selector to which add Contentsquare mask data attribute
	 */
	addMaskAttr: function (elementSelector) {
		setInterval(() => {
			$(elementSelector).attr('data-cs-mask', '');
		}, 50);
	},

	/**
	 * @function
	 * @description format price number adding currency
	 */
	getFormattedPrice: function (priceNumber) {
		return new Intl.NumberFormat('en', {style: 'currency', currency: window.currencyCode || 'GBP'}).format(priceNumber);
	}
};

module.exports = util;
window.util = util;
